import { useEffect, useState } from "react";
export function usePreventScroll() {
    const [preventScrolling, setPreventScrolling] = useState(false);
    useEffect(() => {
        const eventListener = ((event) => {
            if (event instanceof CustomEvent) {
                setPreventScrolling(event.detail);
            }
        });
        document.addEventListener("preventscroll", eventListener);
        return () => {
            document.removeEventListener("preventscroll", eventListener);
        };
    }, []);
    return preventScrolling;
}
